export type IconNames =
    | 'arrow-up'
    | 'arrow-left'
    | 'attachment-outline'
    | 'bell-outline'
    | 'calendar-outline'
    | 'calendar-fill'
    | 'calendar-minimal-outline'
    | 'camera-fill'
    | 'car-outline'
    | 'case-outline'
    | 'chat-outline'
    | 'chat-fill'
    | 'chat-dialog-outline'
    | 'chat-dialog-fill'
    | 'checklist-outline'
    | 'checkmark'
    | 'checkmark-thin'
    | 'checkmark-round'
    | 'chevron-down'
    | 'chevron-left'
    | 'chevron-right'
    | 'chevron-up'
    | 'clipboard-fill'
    | 'clipboard-remove-fill'
    | 'alarm-fill'
    | 'clock-fill'
    | 'clock-outline'
    | 'close'
    | 'close-fill'
    | 'cosmetics-outline'
    | 'credit-card-fill'
    | 'credit-card-outline'
    | 'danger-exclamation-fill'
    | 'document-outline'
    | 'dollar-outline'
    | 'email-outline'
    | 'eye-closed-outline'
    | 'eye-outline'
    | 'eye-fill'
    | 'filter-fill'
    | 'filter-outline'
    | 'heart-outline'
    | 'heart-fill'
    | 'help-lifebuoy-outline'
    | 'home-outline'
    | 'home-fill'
    | 'lightning-bolt-fill'
    | 'list-with-checkmarks'
    | 'location-fill'
    | 'location-outline'
    | 'logout-outline'
    | 'mailbox-fill'
    | 'make-up-fill'
    | 'menu-dots-fill'
    | 'message-dialog-outline'
    | 'message-send-outline'
    | 'minus-thick'
    | 'minus-thin'
    | 'money-transfer-fill'
    | 'money-transfer-outline'
    | 'new-badge-fill'
    | 'notes-outline'
    | 'pen-fill'
    | 'pen-underline-fill'
    | 'perfume-outline'
    | 'phone-outline'
    | 'plus-thin'
    | 'question-circle-outline'
    | 'salon-outline'
    | 'search'
    | 'security-user-outline'
    | 'settings-outline'
    | 'shopping-bag-fill'
    | 'sort-vertical'
    | 'star-fill'
    | 'star-half-fill'
    | 'suitcase-fill'
    | 'trash-outline'
    | 'user-outline'
    | 'user-fill'
    | 'user-block-fill'
    | 'user-block-outline'
    | 'user-id-fill'
    | 'wallet-outline'
    | 'wallet-open-outline'
    | 'gps'
    | 'shield-star-fill';

export type IconNamesObject = { [key in IconNames]: string };

export const iconFileNamePathsObject: IconNamesObject = {
    'arrow-up': 'Bold/Arrows/Alt Arrow Down.svg',
    'arrow-left': 'Outline/Arrows/Arrow Left.svg',
    'attachment-outline': 'Outline/Messages-Conversation/Paperclip Rounded 2.svg',
    'bell-outline': 'Outline/Notifications/Bell.svg',
    'calendar-outline': 'Outline/Time/Calendar.svg',
    'calendar-fill': 'Bold/Time/Calendar.svg',
    'calendar-minimal-outline': 'Outline/Time/Calendar Minimalistic.svg',
    'camera-fill': 'Bold/Video-Audio-Sound/Camera Minimalistic.svg',
    'case-outline': 'Outline/Business-Statistic/Case.svg',
    'car-outline': 'guard-finder/car-outline.svg',
    'chat-outline': 'Outline/Messages-Conversation/Chat Line.svg',
    'chat-fill': 'Bold/Messages-Conversation/Chat Line.svg',
    'chat-dialog-outline': 'Outline/Messages-Conversation/Dialog.svg',
    'chat-dialog-fill': 'Bold/Messages-Conversation/Dialog.svg',
    'checklist-outline': 'Outline/List/Checklist Minimalistic.svg',
    checkmark: 'Outline/Arrows Action/Tick.svg',
    'checkmark-thin': 'Outline/Arrows Action/Tick Round Thin.svg',
    'checkmark-round': 'Outline/Arrows Action/Tick Round.svg',
    'chevron-down': 'Outline/Arrows/Alt Arrow Down.svg',
    'chevron-left': 'Outline/Arrows/Alt Arrow Left.svg',
    'chevron-right': 'Outline/Arrows/Alt Arrow Right.svg',
    'chevron-up': 'Outline/Arrows/Alt Arrow Up.svg',
    'clipboard-fill': 'Bold/Notes/Clipboard.svg',
    'clipboard-remove-fill': 'Bold/Notes/Clipboard Remove.svg',
    'alarm-fill': 'Bold/Time/Alarm.svg',
    'clock-fill': 'Bold/Time/Clock Circle.svg',
    'clock-outline': 'Outline/Time/Clock Circle.svg',
    close: 'Outline/Arrows Action/Close.svg',
    'close-fill': 'Bold/Essential/Close Circle.svg',
    'cosmetics-outline': 'Outline/Essential/Cosmetic.svg',
    'credit-card-fill': 'Bold/Money/Card 2.svg',
    'credit-card-outline': 'Outline/Money/Card.svg',
    'danger-exclamation-fill': 'Bold/Essential/Danger Circle.svg',
    'document-outline': 'Outline/Notes/Document Text.svg',
    'dollar-outline': 'Outline/Money/Dollar.svg',
    'email-outline': 'Outline/Messages-Conversation/Letter.svg',
    'eye-closed-outline': 'Outline/Security/Eye Closed.svg',
    'eye-outline': 'Outline/Security/Eye.svg',
    'eye-fill': 'Bold/Security/Eye.svg',
    'filter-fill': 'Bold/Settings-Fine Tuning/Tuning 2.svg',
    'filter-outline': 'Outline/Settings-Fine Tuning/Tuning 2.svg',
    'heart-outline': 'Outline/Like/Heart.svg',
    'heart-fill': 'Bold/Like/Heart.svg',
    'help-lifebuoy-outline': 'Outline/Essential/Help.svg',
    'home-outline': 'Outline/Essential/Home 2.svg',
    'home-fill': 'Bold/Essential/Home 2.svg',
    'lightning-bolt-fill': 'guard-finder/eva_flash-fill.svg',
    'list-with-checkmarks': 'guard-finder/list-with-checkmarks.svg',
    'location-fill': 'Bold/Map-Location/Map Point.svg',
    'location-outline': 'Outline/Map-Location/point.svg',
    'logout-outline': 'Outline/Arrows Action/Logout.svg',
    'mailbox-fill': 'Bold/Messages-Conversation/Mailbox.svg',
    'make-up-fill': 'Bold/Essential/Cosmetic.svg',
    'menu-dots-fill': 'Bold/Essential/Menu Dots.svg',
    'message-dialog-outline': 'Outline/Messages-Conversation/Dialog 2.svg',
    'message-send-outline': 'Outline/Messages-Conversation/Plain 3.svg',
    'minus-thick': 'Outline/Essential/Minus.svg',
    'minus-thin': 'guard-finder/Minus Thin.svg',
    'money-transfer-fill': 'Bold/Money/Card Transfer.svg',
    'money-transfer-outline': 'Outline/Money/Card Transfer.svg',
    'new-badge-fill': 'guard-finder/mdi_new-box.svg',
    'notes-outline': 'Outline/Notes/Notes.svg',
    'pen-fill': 'Bold/Messages-Conversation/Pen.svg',
    'pen-underline-fill': 'Bold/Messages-Conversation/Pen 2.svg',
    'perfume-outline': 'Outline/Essential/Perfume.svg',
    'phone-outline': 'Outline/Call/Phone Rounded.svg',
    'plus-thin': 'guard-finder/Plus Thin.svg',
    'question-circle-outline': 'Outline/Essential/Question Circle.svg',
    'salon-outline': 'guard-finder/salon-outline.svg',
    search: 'Outline/Search/Magnifer.svg',
    'security-user-outline': 'Outline/Security/Shield User.svg',
    'settings-outline': 'guard-finder/Outline/Settings.svg',
    'shopping-bag-fill': 'Bold/Shopping-Ecommerce/Cart 3.svg',
    'sort-vertical': 'Outline/Arrows/Sort Vertical.svg',
    'star-fill': 'Bold/Like/Star.svg',
    'star-half-fill': 'Bold/Like/Star-Half.svg',
    'suitcase-fill': 'guard-finder/Bold/Suitcase.svg',
    'trash-outline': 'Outline/Essential/Trash Bin Trash.svg',
    'user-outline': 'Outline/Users/User.svg',
    'user-fill': 'Bold/Users/User.svg',
    'user-block-fill': 'Bold/Users/User Block.svg',
    'user-block-outline': 'Outline/Users/User Block.svg',
    'user-id-fill': 'Bold/Users/User Id.svg',
    'wallet-outline': 'Outline/Money/Wallet.svg',
    'wallet-open-outline': 'Outline/Money/Wallet Money.svg',
    gps: 'Bold/Map-Location/GPS.svg',
    'shield-star-fill': 'Bold/Security/Shield Star.svg'
};
